const merge = require('lodash/merge');
const { apiPortfolioId } = require('../../utils');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

function getUrl(endpoint) {
  return `${baseUrl}${endpoint}`;
}

return {
    getLoginTerms(dummyBrch, metaData) {
      const url = getUrl('show-tcpa');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
        branchCode: dummyBrch,
        language: parsedMetaData.portfolio.language,
      } 
      
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },
    
    showTermsConditions(metaData) {
      const url = getUrl('show-termsconditions');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        language: parsedMetaData.portfolio.language,
      } 
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },
    getPaymentLimit(channel,metaData) {
      const url = getUrl('fetchUserPaymentTxLimit');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
      };
      const body = {
        userId: parsedMetaData.qs.userId,
        channel
      } 
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));

    },
    saveTermsConditions(seenTerms, seenPrivacy, channel, termsUrl, privacyUrl, tcVersion, paVersion, metaData) {
      const url = getUrl('save-termsconditions');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        seenTerms: seenTerms,
        seenPrivacy: seenPrivacy,
        channel: channel,
        termsUrl: termsUrl,
        privacyUrl: privacyUrl,
        language: parsedMetaData.portfolio.language,
        tcVersion: tcVersion,
        paVersion: paVersion,
        termsChatUrl: '', 
        seenChatTerms: false,
        tcChatVersion: 0
      } 

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    }, 

    saveTermsConditionsExtended(seenTerms, seenPrivacy, channel, termsUrl, privacyUrl, tcVersion, paVersion, termsChatUrl, seenChatTerms, tcChatVersion, seenSummary, metaData) {
      const url = getUrl('save-termsconditions');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        seenTerms: seenTerms,
        seenPrivacy: seenPrivacy,
        channel: channel,
        termsUrl: termsUrl,
        privacyUrl: privacyUrl,
        language: parsedMetaData.portfolio.language,
        tcVersion: tcVersion,
        paVersion: paVersion,
        termsChatUrl: termsChatUrl,
        seenChatTerms: seenChatTerms,
        tcChatVersion: tcChatVersion,
        seenSSTerms: seenSummary
      } 

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    getTermsConditionsAndRmiaData(metaData) {
      const urls = [
            getUrl('show-termsconditions'),
            getUrl('user-rmia-details'),
      ];
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        language: parsedMetaData.portfolio.language,
      } 
      return Promise.all(urls.map(url => requestHandler(merge(
        reqOpts,{ 
          url, 
          body,
          json: true,
       }))
      )); 
      
    }

  };
}

module.exports = apiFactory;
